// Deterministic per-user avatar helpers.
// - initials(name, email): two-letter, uppercase, falls back to email[0..1]
// - colorFor(userId): consistent hex color picked from a curated palette

const PALETTE = [
  "#f59e0b", // amber
  "#14b8a6", // teal
  "#a78bfa", // violet
  "#60a5fa", // blue
  "#f472b6", // pink
  "#34d399", // emerald
  "#fb923c", // orange
  "#facc15", // yellow
  "#22d3ee", // cyan
  "#c084fc", // purple
];

export function initials(nameOrEmail) {
  const src = (nameOrEmail || "").trim();
  if (!src) return "?";
  // If looks like an email, just take the local-part
  const local = src.includes("@") ? src.split("@")[0] : src;
  const parts = local.split(/[\s._-]+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  if (parts.length === 1) {
    const p = parts[0];
    if (p.length >= 2) return p.slice(0, 2).toUpperCase();
    return p[0].toUpperCase();
  }
  return src.slice(0, 2).toUpperCase();
}

export function colorFor(userId) {
  if (!userId) return PALETTE[0];
  // Tiny deterministic hash
  let h = 0;
  for (let i = 0; i < userId.length; i++) {
    h = (h * 31 + userId.charCodeAt(i)) | 0;
  }
  return PALETTE[Math.abs(h) % PALETTE.length];
}

export function displayName(member) {
  if (!member) return "Unassigned";
  return member.name || member.email || "Unknown";
}
